<template>
  <div>
    <div class="section">
      <div class="container">
        <img src="~../../public/images/martyLeedsSeptenaryCipher.jpg" />
        <div class="columns">
          <div class="column">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      v-on:keyup="parseInput"
                      v-model.trim="userInput"
                      v-on:keyup.enter="saveUserInput"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="control">
                  <label class="checkbox has-padding-left-4">
                    <input
                      type="checkbox"
                      v-model="ignoreConsonants"
                      :disabled="ignoreVowels"
                      @change="parseInput"
                    /> Remove Consonants
                  </label>
                  <label class="checkbox has-padding-left-4">
                    <input
                      type="checkbox"
                      v-model="ignoreVowels"
                      :disabled="ignoreConsonants"
                      @change="parseInput"
                    /> Remove Vowels
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br class="is-clearfix" />
      <div v-if="words" class="container">
        <div v-for="(cipher, index) in selectedCiphers" :key="index">
          <p class="has-text-grey-light">({{totalLetterCount()}} letters, {{words.length}} words)</p>          
          <div v-for="(word, index) in words" :key="index" class="is-inline-block">
            <table class="table is-borderless is-inline-block">
              <thead>
                <tr>
                  <th
                    class="has-text-centered"
                    v-for="(letter, index) in word.letters"
                    :key="index"
                  >{{letter.letter}}</th>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    class="has-text-centered"
                    v-for="(letter,index) in word.letters"
                    :key="index"
                  >{{ cipherValueForLetter(letter, cipher.key) }}</td>
                  <td>
                    <br />
                    <p class="title is-6">{{ cipherValueForWord(word.cipherTotals, cipher.key) }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box has-margin-top-4">
          <div class="title is-4 has-text-centered">
            Gematria total = <span class="has-text-danger">{{cipherValueForInput('s')}}</span>
          </div>
        </div>
      </div>
      <div v-if="shouldShowSavedInput()" class="container has-margin-top-5">
        <div class="columns is-mobile is-centered">
          <div class="column is-two-thirds">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th colspan="2" class="has-text-centered">
                    <p class="title is-4 has-text-grey">Previous Entries</p>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(wordObject,index) in savedInput" :key="index">
                  <td class="has-text-left">{{wordObject.phrase}}</td>
                  <td
                    v-for="cipher in selectedCiphers"
                    :key="cipher.key"
                    class="has-text-centered"
                  >{{wordObject.phraseCipherValues.find(({key}) => key === cipher.key).total}}</td>
                  <td>
                    <font-awesome-icon
                      class="has-text-grey-lighter"
                      :icon="['fas', 'times-circle']"
                      title="Remove saved entry"
                      @click="removeSavedInput(wordObject)"
                    ></font-awesome-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': cipherModalIsVisible }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Select Ciphers</p>
          <button class="delete" aria-label="close" @click="toggleCipherModal"></button>
        </header>
        <section class="modal-card-body">
          <div v-for="cipher in ciphers" :key="cipher.key">
            <label class="checkbox">
              <input type="checkbox" v-model="selectedCiphers" :value="cipher" />
              {{ cipher.name }}
            </label>
          </div>
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="toggleCipherModal"></button>
    </div>
  </div>
</template>

<script>
import { setLettersValue } from '../../database';
export default {
  name: "Calculator",
  data() {
    return {
      userInput: null,
      words: null,
      ignoreConsonants: false,
      ignoreVowels: false,
      savedInput: null,
      ciphers: [
          { key: "s", name: 'Septenary' },
          { key: "o", name: 'Ordinal' },
          { key: 'ro', name: 'Reverse Ordinal' },
          { key: 'fr', name: 'Full Reduction' },
          { key: 'rfr', name: 'Reverse Full Reduction' }],
      selectedCiphers: [{ key: "s", name: "Septenary" }],
      cipherValues: [
        { l: "a", cv: { o: 1, s: 1, ro: 26, fr: 1, rfr: 8 } },
        { l: "b", cv: { o: 2, s: 2, ro: 25, fr: 2, rfr: 7 } },
        { l: "c", cv: { o: 3, s: 3, ro: 24, fr: 3, rfr: 6 } },
        { l: "d", cv: { o: 4, s: 4, ro: 23, fr: 4, rfr: 5 } },
        { l: "e", cv: { o: 5, s: 5, ro: 22, fr: 5, rfr: 4 } },
        { l: "f", cv: { o: 6, s: 6, ro: 21, fr: 6, rfr: 3 } },
        { l: "g", cv: { o: 7, s: 7, ro: 20, fr: 7, rfr: 2 } },
        { l: "h", cv: { o: 8, s: 6, ro: 19, fr: 8, rfr: 1 } },
        { l: "i", cv: { o: 9, s: 5, ro: 18, fr: 9, rfr: 9 } },
        { l: "j", cv: { o: 10, s: 4, ro: 17, fr: 1, rfr: 8 } },
        { l: "k", cv: { o: 11, s: 3, ro: 16, fr: 2, rfr: 7 } },
        { l: "l", cv: { o: 12, s: 2, ro: 15, fr: 3, rfr: 6 } },
        { l: "m", cv: { o: 13, s: 1, ro: 14, fr: 4, rfr: 5 } },
        { l: "n", cv: { o: 14, s: 1, ro: 13, fr: 5, rfr: 4 } },
        { l: "o", cv: { o: 15, s: 2, ro: 12, fr: 6, rfr: 3 } },
        { l: "p", cv: { o: 16, s: 3, ro: 11, fr: 7, rfr: 2 } },
        { l: "q", cv: { o: 17, s: 4, ro: 10, fr: 8, rfr: 1 } },
        { l: "r", cv: { o: 18, s: 5, ro: 9, fr: 9, rfr: 9 } },
        { l: "s", cv: { o: 19, s: 6, ro: 8, fr: 1, rfr: 8 } },
        { l: "t", cv: { o: 20, s: 7, ro: 7, fr: 2, rfr: 7 } },
        { l: "u", cv: { o: 21, s: 6, ro: 6, fr: 3, rfr: 6 } },
        { l: "v", cv: { o: 22, s: 5, ro: 5, fr: 4, rfr: 5 } },
        { l: "w", cv: { o: 23, s: 4, ro: 4, fr: 5, rfr: 4 } },
        { l: "x", cv: { o: 24, s: 3, ro: 3, fr: 6, rfr: 3 } },
        { l: "y", cv: { o: 25, s: 2, ro: 2, fr: 7, rfr: 2 } },
        { l: "z", cv: { o: 26, s: 1, ro: 1, fr: 8, rfr: 1 } }
      ],
      cipherModalIsVisible: false,
      consonants: [
        "b",
        "c",
        "d",
        "f",
        "g",
        "h",
        "j",
        "k",
        "l",
        "m",
        "n",
        "p",
        "q",
        "r",
        "s",
        "t",
        "v",
        "w",
        "x",
        "y",
        "z"
      ],
      vowels: ["a", "e", "i", "o", "u"]
    };
  },
  methods: {
    parseInput: function() {
      this.words = [];

      if (!this.userInput) {
        this.words = null;
        return;
      }

      var inputWords = this.userInput.split(" ");

      if (inputWords.length === 1) {
        if (parseInt(inputWords[0], 10) > 0) {
          // do number things
        } else {
          this.parseWords(inputWords);
        }
      } else {
        this.parseWords(inputWords);
      }
    },
    totalLetterCount: function() {
      let totalLetters = 0;
      if (this.words) {
        this.words.forEach(word => {
          totalLetters += parseInt(word.letters.length, 10);
        });
      }
      return totalLetters;
    },
    parseWords: function(inputWords) {
      inputWords.forEach(word => {
        let letters = [];
        let cipherTotals = [];

        this.ciphers.forEach(cipher => {
          cipherTotals.push({ cipherKey: cipher.key, cipherValue: 0 });
        });

        let wordLetters = word.split("");
        let splitLetters = wordLetters
          .join("|")
          .toLowerCase()
          .split("|");
        let uniqueLetters = [...new Set(splitLetters)];

        if (this.ignoreConsonants) {
          uniqueLetters.forEach(letter => {
            let isConsonant = this.consonants.indexOf(letter) > -1;
            if (isConsonant) {
              while (splitLetters.indexOf(letter) > -1) {
                let index = splitLetters.indexOf(letter);
                splitLetters.splice(index, 1);
              }
            }
          });
        }
        if (this.ignoreVowels) {
          uniqueLetters.forEach(letter => {
            let isVowel = this.vowels.indexOf(letter) > -1;
            if (isVowel) {
              while (splitLetters.indexOf(letter) > -1) {
                let index = splitLetters.indexOf(letter);
                splitLetters.splice(index, 1);
              }
            }
          });
        }

        splitLetters.forEach(splitLetter => {
          let letter = {};
          letter.letter = splitLetter;
          letter.cipherValues = [];

          this.ciphers.forEach(cipher => {
            let cipherKey = cipher.key;

            let cipherValueObject = this.cipherValues.find(
              ({ l }) => l === letter.letter
            );

            let cipherValue = null;
            if (cipherValueObject) {
              cipherValue = cipherValueObject.cv[cipherKey];
            }

            letter.cipherValues.push({
              cipherKey: cipherKey,
              cipherValue: cipherValue
            });

            let cipherTotalObjectIndex = cipherTotals.findIndex(
              obj => obj.cipherKey === cipherKey
            );
            if (cipherTotalObjectIndex > -1) {
              cipherTotals[cipherTotalObjectIndex].cipherValue += cipherValue;
            }
          });

          letters.push(letter);
        });

        if (letters.length > 0) {
          let wordObject = {
            word: letters.map(l => l.letter).join(""),
            letters: letters,
            cipherTotals: cipherTotals
          };

          this.words.push(wordObject);
        }
      });
    },
    cipherValueForLetter: function(letter, letterCipherKey) {
      let letterObject = letter.cipherValues.find(
        ({ cipherKey }) => cipherKey === letterCipherKey
      );
      return letterObject.cipherValue || "";
    },
    cipherValueForWord: function(wordCipherTotals, wordCipherKey) {
      let cipherTotalObject = wordCipherTotals.find(
        ({ cipherKey }) => cipherKey === wordCipherKey
      );
      return cipherTotalObject.cipherValue || "";
    },
    cipherValueForInput: function(inputCipherKey) {
      let total = 0;
      this.words.forEach(word => {
        total += this.cipherValueForWord(word.cipherTotals, inputCipherKey);
      });
      return total;
    },
    cipherValueForSavedInput: function(savedWords, cipherKey) {
      let total = 0;
      savedWords.forEach(word => {
        total += this.cipherValueForWord(word.cipherTotals, cipherKey);
      });
      return total;
    },
    toggleCipherModal: function() {
      this.cipherModalIsVisible = !this.cipherModalIsVisible;
    },
    saveUserInput: function() {
      if (!this.words) {
        return;
      }
      if (!this.savedInput) {
        this.savedInput = [];
      }

      let cipherInputValues = [];
      this.ciphers.forEach(cipher => {
        cipherInputValues.push({
          key: cipher.key,
          total: this.cipherValueForInput(cipher.key)
        });
      });
      let savedInputObject = {
        phrase: this.words.map(w => w.word).join(" "),
        phraseCipherValues: cipherInputValues
      };
      this.savedInput.push(savedInputObject);
      setLettersValue(savedInputObject);
    },
    removeSavedInput: function(savedUserInput) {
      const index = this.savedInput.indexOf(savedUserInput);
      if (index > -1) {
        this.savedInput.splice(index, 1);
      }
    },
    shouldShowSavedInput: function() {
      return this.savedInput && this.savedInput.length > 0;
    },
    consonantCheckboxClick: function() {
      if (this.ignoreConsonants) {
        this.ignoreVowels = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table td,
.table th {
  padding: 0.2em 0.2em;
}
</style>
